export const ibanFormats = {
    EE: {
        length: 20,
        bban: [
            { type: 'fixed', value: '2200' },  // Swedbank Estonia
            { type: 'n', length: 12 }          // Account number
        ]
    },
    DE: {
        length: 22,
        bban: [
            { type: 'fixed', value: '37040044' }, // Commerzbank Köln
            { type: 'n', length: 10 }             // Account number
        ]
    },
    FR: {
        length: 27,
        bban: [
            { type: 'fixed', value: '20041' },  // Bank code (BNP Paribas)
            { type: 'fixed', value: '01005' },  // Branch code (Paris)
            { type: 'n', length: 11 },          // Account number
            { type: 'n', length: 2 }            // RIB key
        ]
    },
    ES: {
        length: 24,
        bban: [
            { type: 'fixed', value: '2100' },   // CaixaBank
            { type: 'fixed', value: '0418' },   // Branch code
            { type: 'n', length: 2 },           // Check digits
            { type: 'n', length: 10 }           // Account number
        ]
    },
    IT: {
        length: 27,
        bban: [
            { type: 'a', length: 1 },           // National check character
            { type: 'fixed', value: '05428' },  // Bank code (Banca Popolare)
            { type: 'fixed', value: '11101' },  // Branch code
            { type: 'c', length: 12 }           // Account number
        ]
    },
    NL: {
        length: 18,
        bban: [
            { type: 'fixed', value: 'ABNA' },   // ABN AMRO Bank
            { type: 'n', length: 10 }           // Account number
        ]
    },
    GB: {
        length: 22,
        bban: [
            { type: 'fixed', value: 'NWBK' },   // NatWest Bank
            { type: 'fixed', value: '601613' }, // Sort code
            { type: 'n', length: 8 }            // Account number
        ]
    },
    BE: {
        length: 16,
        bban: [
            { type: 'fixed', value: '539' },    // Bank code (ING Belgium)
            { type: 'n', length: 7 },           // Account number
            { type: 'n', length: 2 }            // National check digit
        ]
    },
    CH: {
        length: 21,
        bban: [
            { type: 'fixed', value: '00762' },  // Bank code (Credit Suisse)
            { type: 'n', length: 12 }           // Account number
        ]
    },
    AT: {
        length: 20,
        bban: [
            { type: 'fixed', value: '43510' },  // Bank code (BAWAG P.S.K.)
            { type: 'n', length: 11 }           // Account number
        ]
    },
    SE: {
        length: 24,
        bban: [
            { type: 'fixed', value: '500' },    // Bank code (Swedbank)
            { type: 'n', length: 17 }           // Account number
        ]
    },
    NO: {
        length: 15,
        bban: [
            { type: 'fixed', value: '8601' },   // Bank code (DNB)
            { type: 'n', length: 6 },           // Account number
            { type: 'n', length: 1 }            // Check digit
        ]
    },
    DK: {
        length: 18,
        bban: [
            { type: 'fixed', value: '0040' },   // Bank code (Danske Bank)
            { type: 'n', length: 10 }           // Account number
        ]
    },
    FI: {
        length: 18,
        bban: [
            { type: 'fixed', value: '123456' }, // Bank code (Nordea)
            { type: 'n', length: 7 },           // Account number
            { type: 'n', length: 1 }            // Check digit
        ]
    },
    PT: {
        length: 25,
        bban: [
            { type: 'fixed', value: '0001' },   // Bank code (Banco de Portugal)
            { type: 'fixed', value: '0123' },   // Branch code
            { type: 'n', length: 11 },          // Account number
            { type: 'n', length: 2 }            // Check digits
        ]
    },
    PL: {
        length: 28,
        bban: [
            { type: 'fixed', value: '10901014' }, // Bank code (Bank Zachodni WBK)
            { type: 'n', length: 16 }             // Account number
        ]
    },
    CZ: {
        length: 24,
        bban: [
            { type: 'fixed', value: '0800' },   // Bank code (Česká spořitelna)
            { type: 'n', length: 16 }           // Account number
        ]
    },
    SK: {
        length: 24,
        bban: [
            { type: 'fixed', value: '1200' },   // Bank code (Slovenská sporiteľňa)
            { type: 'n', length: 16 }           // Account number
        ]
    },
    HU: {
        length: 28,
        bban: [
            { type: 'fixed', value: '117' },    // Bank code (OTP Bank)
            { type: 'fixed', value: '7301' },   // Branch code
            { type: 'n', length: 16 },          // Account number
            { type: 'n', length: 1 }            // Check digit
        ]
    },
    RO: {
        length: 24,
        bban: [
            { type: 'fixed', value: 'AAAA' },   // Bank code (Alpha Bank)
            { type: 'c', length: 16 }           // Account number
        ]
    },
    BG: {
        length: 22,
        bban: [
            { type: 'fixed', value: 'BNBG' },   // Bank code (Bulgarian National Bank)
            { type: 'n', length: 4 },           // Branch code
            { type: 'n', length: 2 },           // Account type
            { type: 'c', length: 8 }            // Account number
        ]
    },
    LV: {
        length: 21,
        bban: [
            { type: 'fixed', value: 'HABA' },   // Example bank code (can be "HABA" for Swedbank)
            { type: 'c', length: 13 }           // Account number (alphanumeric)
        ]
    },
    LT: {
        length: 20,
        bban: [
            { type: 'fixed', value: '40100' },  // Bank code (10000 for Lietuvos bankas / Swedbank)
            { type: 'n', length: 11 }           // Account number
        ]
    }
};